import { NgModule } from '@angular/core';

import { LayoutRoutingModule } from './layout-routing.module';
import { SharedModule } from '../shared/shared.module';
import { ToasterModule } from 'angular2-toaster';
import { TranslateModule } from 'ng2-translate';

@NgModule({
    imports: [
        LayoutRoutingModule,
        SharedModule,
        ToasterModule,
        TranslateModule
    ],
    declarations: []
})

export class LayoutModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/layout.module.ts